// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TopPanel - Unified top panel component */
.top-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  z-index: 1000;
  pointer-events: none;
  height: 40px;
  padding: 10px 20px;
  background-color: var(--color-background);
  border-bottom: 1px solid var(--border-color);
  backdrop-filter: blur(8px);

  /* Instant transitions - 0ms duration as required */
  transition: none;
  transition-duration: 0ms;
  transition-delay: 0ms;

  /* Ensure no animations */
  animation: none;
}

/* Enable pointer events for interactive elements */
.top-panel > * {
  pointer-events: auto;
}

/* Left side - Navigation */
.top-panel-left {
  display: flex;
  align-items: center;
}

/* Spacer to push content right when no navigation */
.top-panel-spacer {
  flex: 1 1;
}

.top-panel-nav {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.nav-link {
  color: var(--color-surface-text);
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: none;

  /* Hover effects with instant response */
  background-color: transparent;
}

.nav-link:hover {
  background-color: var(--hover-overlay);
  transition: none;
}

.nav-link:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* Right side - User info and controls */
.top-panel-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-email {
  color: var(--color-surface-text);
  font-size: 14px;
  margin-right: 0.5rem;
}

.logout-button {
  padding: 0.5rem 1rem;
  background-color: var(--color-primary);
  color: var(--color-primary-text);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  /* Instant transitions */
  transition: none;
}

.logout-button:hover {
  background-color: var(--color-primary-hover, var(--color-primary));
  transition: none;
}

.logout-button:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.logout-button:active {
  transform: none;
  transition: none;
}

/* Responsive behavior - identical layout at all screen sizes */
/* No responsive breakpoints as per requirements */
@media screen and (max-width: 768px) {
  .top-panel {
    /* Maintain identical layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    pointer-events: none;
    height: 40px;
    padding: 10px 20px;
    background-color: var(--color-background);
    border-bottom: 1px solid var(--border-color);
  }

  .top-panel-right {
    gap: 0.75rem; /* Slightly smaller gap on mobile but same structure */
  }
}

@media screen and (max-width: 480px) {
  .top-panel {
    /* Still maintain identical layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    pointer-events: none;
    height: 40px;
    padding: 10px 20px;
    background-color: var(--color-background);
    border-bottom: 1px solid var(--border-color);
  }

  .user-email {
    font-size: 12px; /* Slightly smaller text but same position */
  }

  .logout-button {
    padding: 0.4rem 0.8rem;
    font-size: 12px;
  }
}

/* Ensure all child elements have no transitions */
.top-panel * {
  transition: none !important;
  transition-duration: 0ms !important;
  transition-delay: 0ms !important;
  animation: none !important;
}

/* Focus management for accessibility */
.top-panel:focus-within {
  /* Ensure focus is visible */
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .nav-link {
    border: 1px solid transparent;
  }

  .nav-link:hover,
  .nav-link:focus {
    border-color: currentColor;
  }

  .logout-button {
    border: 1px solid var(--color-primary);
  }
}

/* Reduced motion support (still 0ms but respect user preferences) */
@media (prefers-reduced-motion: reduce) {
  .top-panel,
  .top-panel * {
    transition: none !important;
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TopPanel.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,4CAA4C;EAC5C,0BAA0B;;EAE1B,mDAAmD;EACnD,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;;EAErB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;;EAEhB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;;EAEhB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D,kDAAkD;AAClD;EACE;IACE,8BAA8B;IAC9B,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,4CAA4C;EAC9C;;EAEA;IACE,YAAY,EAAE,sDAAsD;EACtE;AACF;;AAEA;EACE;IACE,oCAAoC;IACpC,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,4CAA4C;EAC9C;;EAEA;IACE,eAAe,EAAE,4CAA4C;EAC/D;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA,kDAAkD;AAClD;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA,oEAAoE;AACpE;EACE;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF","sourcesContent":["/* TopPanel - Unified top panel component */\n.top-panel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  z-index: 1000;\n  pointer-events: none;\n  height: 40px;\n  padding: 10px 20px;\n  background-color: var(--color-background);\n  border-bottom: 1px solid var(--border-color);\n  backdrop-filter: blur(8px);\n\n  /* Instant transitions - 0ms duration as required */\n  transition: none;\n  transition-duration: 0ms;\n  transition-delay: 0ms;\n\n  /* Ensure no animations */\n  animation: none;\n}\n\n/* Enable pointer events for interactive elements */\n.top-panel > * {\n  pointer-events: auto;\n}\n\n/* Left side - Navigation */\n.top-panel-left {\n  display: flex;\n  align-items: center;\n}\n\n/* Spacer to push content right when no navigation */\n.top-panel-spacer {\n  flex: 1;\n}\n\n.top-panel-nav {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.nav-link {\n  color: var(--color-surface-text);\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  transition: none;\n\n  /* Hover effects with instant response */\n  background-color: transparent;\n}\n\n.nav-link:hover {\n  background-color: var(--hover-overlay);\n  transition: none;\n}\n\n.nav-link:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n/* Right side - User info and controls */\n.top-panel-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-email {\n  color: var(--color-surface-text);\n  font-size: 14px;\n  margin-right: 0.5rem;\n}\n\n.logout-button {\n  padding: 0.5rem 1rem;\n  background-color: var(--color-primary);\n  color: var(--color-primary-text);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n\n  /* Instant transitions */\n  transition: none;\n}\n\n.logout-button:hover {\n  background-color: var(--color-primary-hover, var(--color-primary));\n  transition: none;\n}\n\n.logout-button:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n.logout-button:active {\n  transform: none;\n  transition: none;\n}\n\n/* Responsive behavior - identical layout at all screen sizes */\n/* No responsive breakpoints as per requirements */\n@media screen and (max-width: 768px) {\n  .top-panel {\n    /* Maintain identical layout */\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n    pointer-events: none;\n    height: 40px;\n    padding: 10px 20px;\n    background-color: var(--color-background);\n    border-bottom: 1px solid var(--border-color);\n  }\n\n  .top-panel-right {\n    gap: 0.75rem; /* Slightly smaller gap on mobile but same structure */\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .top-panel {\n    /* Still maintain identical layout */\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: space-between;\n    gap: 0.75rem;\n    pointer-events: none;\n    height: 40px;\n    padding: 10px 20px;\n    background-color: var(--color-background);\n    border-bottom: 1px solid var(--border-color);\n  }\n\n  .user-email {\n    font-size: 12px; /* Slightly smaller text but same position */\n  }\n\n  .logout-button {\n    padding: 0.4rem 0.8rem;\n    font-size: 12px;\n  }\n}\n\n/* Ensure all child elements have no transitions */\n.top-panel * {\n  transition: none !important;\n  transition-duration: 0ms !important;\n  transition-delay: 0ms !important;\n  animation: none !important;\n}\n\n/* Focus management for accessibility */\n.top-panel:focus-within {\n  /* Ensure focus is visible */\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .nav-link {\n    border: 1px solid transparent;\n  }\n\n  .nav-link:hover,\n  .nav-link:focus {\n    border-color: currentColor;\n  }\n\n  .logout-button {\n    border: 1px solid var(--color-primary);\n  }\n}\n\n/* Reduced motion support (still 0ms but respect user preferences) */\n@media (prefers-reduced-motion: reduce) {\n  .top-panel,\n  .top-panel * {\n    transition: none !important;\n    animation: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
